import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { DrawerListComponent } from './drawer-list/drawer-list';
import { DrawerItemComponent } from './drawer-item/drawer-item';
import { IonicModule } from 'ionic-angular';
import { DrawerHeaderComponent } from './drawer-header/drawer-header';
import { ProdutoItemComponent } from './produto-item/produto-item';

@NgModule({
	declarations: [
		DrawerListComponent,
		DrawerItemComponent,
		DrawerHeaderComponent,
		ProdutoItemComponent,
	],
	imports: [
		CommonModule,
		BrowserModule,
		IonicModule.forRoot(DrawerListComponent)
	],
	exports: [
		DrawerListComponent,
		DrawerItemComponent,
		DrawerHeaderComponent,
		ProdutoItemComponent,
	]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts